export default "__VITE_PUBLIC_ASSET__82f6137f__"